/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    
    async onSubmitHandler() {
      // Prevent multiple clicks
      if (this.classList.contains('loading')) {
        return;
      }
      
      this.classList.add('loading');
      
      try {
        // Get cart notes if the element exists
        const notesElement = document.getElementById('mini-cart__notes');
        const note = notesElement ? notesElement.value : '';
        
        // Use the correct Shopify cart clear endpoint
        const clearUrl = theme?.routes?.cart_clear_url || '/cart/clear.js';
        
        const response = await fetch(clearUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            'note': note
          })
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Remove loading state
        this.classList.remove('loading');
        
        // Refresh the cart drawer
        if (this.drawer && typeof this.drawer.refresh === 'function') {
          this.drawer.refresh();
        } else {
          // Fallback: dispatch cart refresh event
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          
          // Try to reload cart drawer manually
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.refresh) {
            cartDrawer.refresh();
          } else {
            // Last resort: reload the page or update cart via fetch
            window.location.reload();
          }
        }
        
      } catch (error) {
        console.error('Error clearing cart:', error);
        
        // Remove loading state even on error
        this.classList.remove('loading');
        
        // Show error message to user
        const errorMessage = document.createElement('div');
        errorMessage.className = 'cart-error-message';
        errorMessage.textContent = 'Failed to clear cart. Please try again.';
        errorMessage.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #f44336; color: white; padding: 15px 20px; border-radius: 8px; z-index: 10000;';
        document.body.appendChild(errorMessage);
        
        setTimeout(() => {
          errorMessage.remove();
        }, 3000);
      }
    }
  }
  
  customElements.define('remove-all', RemoveAll);
}

